
















// vue
import {Vue, Component, Watch} from 'vue-property-decorator';

// 组件
import RootColStyleOne from './RootColStyleOne.vue';
import LayoutOne from '@/components/layouts/LayoutOne.vue';
import {Toast} from 'vant';

// http
import http from '@/utils/http';
import {newsDetailAPI} from '@/api/index';

@Component({
  components: {
    styleOne: RootColStyleOne,
    layoutOne: LayoutOne,
  },
})
export default class App extends Vue {
  public layoutStyle: string = 'layoutOne';
  public mainStyle: string = 'styleOne';

  public data: any = {};

  public articleData: any = {};

  @Watch('$route')
  public watchData(value: any) {
    this.data = JSON.parse(value.query.data as string);
    this.getFirstArticleData();
  }

  public mounted() {
    const query = this.$route.query;
    this.data = JSON.parse(query.data as string);
    const id = query.id;

    if (!id || id === '0') {
      this.getFirstArticleData();
    } else {
      let selectIndex = 0;
      const idItem = this.data.subList.find((value: any, index: number) => {
        if (value.id == id) {
          selectIndex = index;
          return true;
        }
      });

      if (idItem) {
        this.columnClick(idItem);
        (this.$refs.content as any).activeIndex = selectIndex;
      }
    }
  }

  // 查询首个图文
  public getFirstArticleData() {
    const subList = this.data.subList;

    if (subList && subList.length) {
      this.getArticleData(subList[0]);
    }
  }

  // 点击栏目
  public columnClick(item: any) {
    this.getArticleData(item).then((res: any) => {
      const {title} = res;

      if (title) {
        const isHttp: boolean = (title as string).startsWith('http');
        const isHtts: boolean = (title as string).startsWith('https');

        if (isHttp || isHtts) {
          window.location.assign(title);
        } else {
          window.location.assign('http://' + title);
        }
      }
    });
  }

  // 获取图文信息
  public getArticleData(item: any) {
    return new Promise((resolve, reject) => {
      const {id, catType} = item;
      const body = {
        pid: id,
        type: catType,
      };

      const {requestInit} = newsDetailAPI;

      requestInit.body = JSON.stringify(body);

      http(newsDetailAPI).then((data: any) => {
        this.articleData = data;
        resolve(data);
      }).catch((reason) => {
        Toast('文章获取失败');
        reject(reason);
      });
    });
  }
}
